/* eslint-disable complexity */
import { SHIFT } from 'models/baselines';
import { CompanyIncrementalDay } from '../Incrementals.types';
import { UiCommands } from './UiCommands';

// eslint-disable-next-line max-statements
export function changeValueCommand(
  this: UiCommands,
  companyIncrementalDay: CompanyIncrementalDay,
  shift: SHIFT,
  value: string
) {
  const companyIncrementalDayEdit = companyIncrementalDay;

  // if value already is same, nothing to set
  if (
    shift === SHIFT.DAY &&
    companyIncrementalDayEdit.userValue != null &&
    companyIncrementalDayEdit.userValue.day === value
  ) {
    return;
  }

  if (
    shift === SHIFT.NIGHT &&
    companyIncrementalDayEdit.userValue != null &&
    companyIncrementalDayEdit.userValue.night === value
  ) {
    return;
  }

  // if userValue has no data at all, initialize, otherwise use the existing data
  if (companyIncrementalDayEdit.userValue == null) {
    companyIncrementalDayEdit.userValue = { day: null, night: null };
  }

  // If ui tries to set a negative, set user value to 0
  const newValue = Number(value) < 0 ? '0' : value;

  if (shift === SHIFT.DAY) {
    companyIncrementalDayEdit.userValue.day = newValue;
  }

  if (shift === SHIFT.NIGHT) {
    companyIncrementalDayEdit.userValue.night = newValue;
  }

  this.setUiStateTriggerReRender(this.uiState);
}
